const OverstockRenderer = ({ data }) => {
  const sub = [data.dosage, data.presentation].filter(Boolean).join(' · ');
  return (
    <>
      <p className="bell-card__name">{data.productName || '—'}</p>
      {sub && <p className="bell-card__sub">{sub}</p>}
      <p className="bell-card__detail">
        Qté : <strong>{data.quantity}</strong> (seuil : {data.maximumStock})
      </p>
    </>
  );
};

export default OverstockRenderer;
